import { site } from '@panel/commons/helpers';
import * as types from './types';
import { createReducer } from '../../utils';

const initialState = {
  selectedProduct: {},
  ecommerceUser: { billingInfo: {} },
  taxConditions: [],
  availableLocations: { states: null, cities: null, zones: null, subZones: null },
  productTaxes: null,
  selectedLocation: '',
  disablePayment: true,
  error: null,
  order: null,
  manualLoading: false
};

const locationLevels = new Map([['', 'states'], ['B', 'cities'], ['C', 'zones'], ['D', 'subZones']]);

const getLocationLevel = (locationId = '') => {
  const locationLevelId = locationId && locationId.split('-')[1];
  return locationLevels.get(locationLevelId);
};

const setDisablePayment = user => {
  const { idClienteSap, address, postalCode, legalName, ecommerceTaxId, taxCondition } = user.billingInfo;
  if (idClienteSap) {
    return false;
  }
  if (site.isPeru || site.isBrasil) {
    return ![address, postalCode, legalName, ecommerceTaxId, taxCondition].every(elem => !!elem);
  }
  return ![legalName, ecommerceTaxId, taxCondition].every(elem => !!elem);
};

const step4Module2Reducer = createReducer(initialState)({
  [types.SET_SELECTED_PRODUCT]: (state, action) => ({ ...state, selectedProduct: action.payload }),
  [types.SET_SELECTED_LOCATION]: (state, action) => {
    const locationLvl = getLocationLevel(action.payload);
    if (locationLvl === 'cities') {
      return {
        ...state,
        selectedLocation: action.payload,
        availableLocations: { ...state.availableLocations, zones: null, subZones: null }
      };
    }
    if (locationLvl === 'zones') {
      return {
        ...state,
        selectedLocation: action.payload,
        availableLocations: { ...state.availableLocations, subZones: null }
      };
    }
    return { ...state, selectedLocation: action.payload };
  },
  [types.GET_ECOMMERCE_USER]: state => ({ ...state, loading: true }),
  [types.GET_ECOMMERCE_USER_COMPLETED]: (state, action) => ({
    ...state,
    ecommerceUser: action.payload,
    ecommerceUserError: false,
    loading: false,
    disablePayment: setDisablePayment(action.payload)
  }),
  [types.GET_ECOMMERCE_USER_FAILED]: state => ({
    ...state,
    ecommerceUserError: true,
    loading: false
  }),
  [types.GET_TAX_CONDITIONS]: state => ({ ...state, loading: true }),
  [types.GET_TAX_CONDITIONS_COMPLETED]: (state, action) => ({
    ...state,
    taxConditions: action.payload,
    taxConditionsError: false,
    loading: false
  }),
  [types.GET_TAX_CONDITIONS_FAILED]: state => ({ ...state, taxConditionsError: true, loading: false }),
  [types.GET_PRODUCT_TAXES]: state => ({ ...state, loading: true, error: null }),
  [types.GET_PRODUCT_TAXES_COMPLETED]: (state, action) => ({
    ...state,
    productTaxes: action.payload,
    loading: false,
    productTaxesError: false
  }),
  [types.GET_PRODUCT_TAXES_FAILED]: (state, action) => ({
    ...state,
    loading: false,
    productTaxesError: true,
    error: action.payload.data
  }),
  [types.UPDATE_PRODUCT_TAXES]: state => ({ ...state, loading: true }),
  [types.UPDATE_PRODUCT_TAXES_COMPLETED]: (state, action) => ({
    ...state,
    productTaxes: action.payload,
    loading: false,
    disablePayment: false,
    productTaxesError: false
  }),
  [types.UPDATE_PRODUCT_TAXES_FAILED]: state => ({
    ...state,
    loading: false,
    enablePayment: false,
    productTaxesError: true
  }),
  [types.GET_LOCATION_LEVEL]: state => ({ ...state, loading: true }),
  [types.GET_LOCATION_LEVEL_COMPLETED]: (state, action) => {
    const lvlName = getLocationLevel(state.selectedLocation || '');
    const locationLevelArr = Object.keys(action.payload).map(key => ({ id: key, name: action.payload[key] }));
    return {
      ...state,
      availableLocations: {
        ...state.availableLocations,
        [lvlName]: locationLevelArr.length > 0 ? locationLevelArr : null
      },
      loading: false
    };
  },
  [types.SET_PAYMENT_LOADER]: (state, action) => ({ ...state, manualLoading: action.payload }),
  [types.SET_TAX_CONDITIONS]: (state, action) => ({ ...state, taxConditions: action.payload }),
  [types.CREATE_INACTIVE_ORDER]: state => ({ ...state, order: null, loading: true }),
  [`${types.CREATE_INACTIVE_ORDER}_COMPLETED`]: (state, action) => ({
    ...state,
    loading: false,
    order: action.payload
  }),
  [`${types.CREATE_INACTIVE_ORDER}_FAILED`]: state => ({ ...state, loading: false, order: null })
});

export { step4Module2Reducer };
